module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/wave_bottom-f19d43ff9e432d291cf127b1ad3b44e8.png";